import { render } from "./MedAl.vue?vue&type=template&id=b9b42220"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/MedAl.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b9b42220"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b9b42220', __exports__)) {
    api.reload('b9b42220', __exports__)
  }
  
  module.hot.accept("./MedAl.vue?vue&type=template&id=b9b42220", () => {
    api.rerender('b9b42220', render)
  })

}


export default __exports__